<template>
  <div>
    <component :is="layout">
      <router-view></router-view>
      <ToastNotify
        :title="dataToast.title"
        :message="dataToast.message"
        :icon="dataToast.icon"
        :status="dataToast.status"
        v-model:open="dataToast.open"
      />
    </component>
    <scroll-to-top />
  </div>
</template>

<script setup>
import { useToast } from "@/store/toast";
import { storeToRefs } from "pinia";

import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { scrollToUp } from './core/utils/globals'
import ScrollToTop from '@/components/scroll-to-top/scroll-to-top.vue'
import LayoutDefault from '@/layouts/default/default.vue'
import LayoutBlank from '@/layouts/blank/blank.vue'
import { useDataInit } from './core/composables/useDataInit'
import ToastNotify from './components/utility/toastNotify.vue'

// Obteniendo la ruta
const route = useRoute()
const toastStore = useToast()
const { dataToast } = storeToRefs(toastStore)

// Computed para obtener el layout basado en la meta de la ruta
const layout = computed(() => {
  const layoutName = route.meta.layout
  return layoutName === 'blank' ? LayoutBlank : LayoutDefault
})

// Ejecutar las funciones cuando el componente se monta
onMounted(() => {
  scrollToUp()
  useDataInit()
})
</script>

<style>
button {
  cursor: pointer;
}
</style>